/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPlanChangeApprovalRequestRejectResponseData
 */
export interface PostPlanChangeApprovalRequestRejectResponseData {
    /**
     * プラン変更承認依頼の却下メールの送信に成功したか
     * @type {boolean}
     * @memberof PostPlanChangeApprovalRequestRejectResponseData
     */
    isSentSuccess: boolean;
    /**
     * プラン変更承認依頼の却下メールを送信したメールアドレス
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestRejectResponseData
     */
    sentMailAddress: string;
}

export function PostPlanChangeApprovalRequestRejectResponseDataFromJSON(json: any): PostPlanChangeApprovalRequestRejectResponseData {
    return PostPlanChangeApprovalRequestRejectResponseDataFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestRejectResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestRejectResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSentSuccess': json['is_sent_success'],
        'sentMailAddress': json['sent_mail_address'],
    };
}

export function PostPlanChangeApprovalRequestRejectResponseDataToJSON(value?: PostPlanChangeApprovalRequestRejectResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_sent_success': value.isSentSuccess,
        'sent_mail_address': value.sentMailAddress,
    };
}

